import { render, staticRenderFns } from "./targetAgainstUserTabs.vue?vue&type=template&id=069788a1&scoped=true"
import script from "./targetAgainstUserTabs.vue?vue&type=script&lang=js"
export * from "./targetAgainstUserTabs.vue?vue&type=script&lang=js"
import style0 from "./targetAgainstUserTabs.vue?vue&type=style&index=0&id=069788a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069788a1",
  null
  
)

export default component.exports